export const dashboardTranslationsNL = {
    amountOfDrafts_one: 'Er is momenteel {{count}} onbekend product bij deze verzending',
    amountOfDrafts_other: 'Er zijn momenteel {{count}} onbekende producten bij deze verzending',
    dashboardRangeToLarge: 'Selecteer maximaal 7 dagen',
};
